/**
 * PURPOSE: Actions that trigger push to dms will be processed by this middleware.
 */

// libraries
import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import { dealerSelectors } from '@makemydeal/dr-shared-store';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';
import { MANAGER_VIEW_APP_PREFIX } from '@makemydeal/dr-shared-ui-utils';

// actions
import * as offerActionCreators from '../actions/offerActionCreators';
import * as pushToDmsActionCreators from '../actions/pushToDmsActionCreators';
import { logCdmsNR, setFlowStartTime } from '../utils/cdmsNrUtils';

// consts/enums
import {
    OFFER_SAVE_SUCCESS,
    OFFER_SAVE_FAILURE,
    LINKS_SUCCESS,
    LINKS_FAILURE,
    OFFER_SAVE_NOCHANGE_SUCCESS,
    SOFT_SAVE_SUCCESS,
    SOFT_SAVE_FAILURE
} from '../actionTypes/offerActionTypes';
import { PUSH_TO_DMS, PUSH_TO_DMS_PLUS, PUSH_TO_DMS_FAILURE, PUSH_TO_DMS_RESPONSE } from '../actionTypes/pushToDmsActionTypes';
import { PUSH_TO_DMS_FLOW, FIIA_DMS_INTEGRATIONS, CDMS } from '../constants';

// interfaces/types
import type { DashMiddleware, DashStore, DashNext } from '@makemydeal/dr-shared-store';

export const middleware: DashMiddleware = (store: DashStore) => (next: DashNext) => (action: AnyFSA) => {
    // Enrich PUSH_TO_DMS_RESPONSE with exportBy from the offer state (set on init)
    if (action.type === PUSH_TO_DMS_RESPONSE) {
        const state = store.getState() as any;
        action.meta = { ...action.meta, exportBy: state.offer?.dealerUser || '' };
    }

    next(action);
    const state = store.getState();
    const isCDMS = dealerSelectors.getDMSIntegrationToggle(state) === CDMS;

    switch (action.type) {
        case PUSH_TO_DMS_PLUS:
        case PUSH_TO_DMS: {
            setFlowStartTime(Date.now());
            store.dispatch(offerActionCreators.saveOffer({ source: PUSH_TO_DMS_FLOW }));
            break;
        }
        case LINKS_SUCCESS:
        case SOFT_SAVE_SUCCESS:
        case OFFER_SAVE_NOCHANGE_SUCCESS:
        case OFFER_SAVE_SUCCESS: {
            const offerSaveSource = action.meta?.source;
            if (offerSaveSource === PUSH_TO_DMS_FLOW) {
                /* istanbul ignore next */
                if (isCDMS) logCdmsNR('OfferSave', 'success');
                if (!FIIA_DMS_INTEGRATIONS.includes(dealerSelectors.getDMSIntegrationToggle(state))) {
                    store.dispatch(pushToDmsActionCreators.pushToDmsRSAA(MANAGER_VIEW_APP_PREFIX, state));
                }
            }
            break;
        }
        case LINKS_FAILURE:
        case SOFT_SAVE_FAILURE:
        case OFFER_SAVE_FAILURE: {
            const offerSaveFailureSource = action.meta?.source;
            if (offerSaveFailureSource === PUSH_TO_DMS_FLOW) {
                /* istanbul ignore next */
                if (isCDMS) logCdmsNR('OfferSave', 'failure', action.payload);
                store.dispatch(pushToDmsActionCreators.dmsError(500));
            }
            break;
        }
        case PUSH_TO_DMS_FAILURE: {
            /* istanbul ignore next */
            if (isCDMS) logCdmsNR('CdmsApi', 'failure', action.payload);
            store.dispatch(pushToDmsActionCreators.dmsError(500));
            break;
        }
        case PUSH_TO_DMS_RESPONSE: {
            const enableCdmsSyncFlow = featureToggleSelectors.enableCdmsSyncFlow(state);
            if (enableCdmsSyncFlow && action.payload) {
                store.dispatch(pushToDmsActionCreators.cdmsSyncBaggageRSAA(MANAGER_VIEW_APP_PREFIX, state, action.payload));
            }
            break;
        }
    }
};
